export const Logo3D = ({ className = "" }) => (
  <div className={`coin3d ${className}`} data-testid="logo-3d">
    <div className="coin3d__inner">
      <div className="coin3d__face coin3d__front">JV</div>
      <div className="coin3d__face coin3d__back">JV</div>
    </div>
  </div>
);

export default Logo3D;
